// extracted by mini-css-extract-plugin
export var standaloneTable = "_i0-0";
export var standaloneTableWithBodyFill = "_i0-1";
export var withExtraHeader = "_i0-2";